"use client";

import {useEffect, useRef} from "react";

import {usePathname, useSearchParams} from "next/navigation";

declare global {
    interface Window {
        fbq?: (...args: Array<unknown>) => void;
    }
}

export function MetaPixelPageTracker(): null {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        window.fbq?.("track", "PageView");
    }, [pathname, searchParams]);

    return null;
}
